import React, { Children } from 'react';
const PrivacyPolicy = () => {
  return <div className="bg-gray-50 min-h-screen" data-id="element-354">
      <div className="bg-[#1a3a6c] text-white py-16" data-id="element-355">
        <div className="container mx-auto px-4 text-center" data-id="element-356">
          <h1 className="text-4xl font-bold mb-6" data-id="element-357">Privacy & Cookie Policy</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-358">
            Information about how we collect, use, and protect your data.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-359">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-360">
          <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-361">
            Privacy and Cookie Policy - Opticore
          </h2>
          <p className="text-gray-700 mb-8" data-id="element-362">
            At Opticore, protecting your privacy is a priority. This policy
            explains what information we collect, how we use it, and how we keep
            it secure, ensuring you have confidence in our handling of your
            personal data.
          </p>
          <div className="space-y-8" data-id="element-363">
            <section data-id="element-364">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-365">
                1. Who We Are
              </h3>
              <p className="text-gray-700" data-id="element-366">
                Opticore is a UK-based appliance repair and service company
                specializing in essential household systems like washing
                machines, boilers, and drainage systems.
              </p>
            </section>
            <section data-id="element-367">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-368">
                2. What Information We Collect
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-369">
                We may collect the following information from you to provide our
                services and manage your account effectively:
              </p>
              <ul className="list-disc pl-6 text-gray-700" data-id="element-370">
                <li data-id="element-371">
                  Your name and contact details: Including your address, email
                  (raimanish3080@gmail.com), and phone number (0800 055 4969).
                </li>
                <li data-id="element-372">
                  Payment information: Processed securely through our trusted
                  payment providers.
                </li>
                <li data-id="element-373">
                  Records of your service plans and repair history: To ensure
                  continuity of service and support.
                </li>
              </ul>
            </section>
            <section data-id="element-374">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-375">
                3. How We Use Your Information
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-376">
                We use your data primarily to:
              </p>
              <ul className="list-disc pl-6 text-gray-700" data-id="element-377">
                <li data-id="element-378">
                  Manage and administer your service plans: Including
                  activation, renewals, and plan adjustments.
                </li>
                <li data-id="element-379">
                  Arrange repairs and provide customer support: Dispatching
                  engineers for your washing machine, boiler, or drainage
                  system, and addressing your queries.
                </li>
                <li data-id="element-380">
                  Send important updates and information: Related to your
                  service, appointments, and policy changes.
                </li>
                <li data-id="element-381">
                  Comply with legal and regulatory obligations: Ensuring we
                  operate within the law.
                </li>
              </ul>
            </section>
            <section data-id="element-382">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-383">
                4. Third-Party Providers
              </h3>
              <p className="text-gray-700" data-id="element-384">
                We work with trusted third parties, such as payment processors
                and website hosting providers, to deliver our services
                efficiently and securely. We want to assure you that we do not
                sell your personal information to any third parties.
              </p>
            </section>
            <section data-id="element-385">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-386">
                5. Cookies
              </h3>
              <p className="text-gray-700" data-id="element-387">
                Our website uses cookies to enhance your browse experience and
                improve site performance. Cookies are small data files stored on
                your device that help us understand how you interact with our
                site. You can manage or disable cookies through your browser
                settings at any time, but please note this may affect certain
                website functionalities.
              </p>
            </section>
            <section data-id="element-388">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-389">
                6. Your Rights
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-390">
                Under applicable data protection laws, you have specific rights
                regarding your personal data. You have the right to:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4" data-id="element-391">
                <li data-id="element-392">Request access to the personal data we hold about you.</li>
                <li data-id="element-393">Ask for corrections or deletion of your data.</li>
                <li data-id="element-394">
                  Withdraw your consent to marketing communications at any time.
                </li>
              </ul>
              <p className="text-gray-700" data-id="element-395">
                To exercise these rights, please contact us at:
              </p>
              <ul className="list-disc pl-6 text-gray-700" data-id="element-396">
                <li data-id="element-397">Email: raimanish3080@gmail.com</li>
                <li data-id="element-398">Phone: 0800 055 4969</li>
              </ul>
            </section>
            <section data-id="element-399">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-400">
                7. Sharing Your Data
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-401">
                We may share your information with:
              </p>
              <ul className="list-disc pl-6 text-gray-700" data-id="element-402">
                <li data-id="element-403">
                  Service providers essential to our operations: Such as payment
                  processors, IT support, and website hosting services, who act
                  on our behalf.
                </li>
                <li data-id="element-404">
                  Law enforcement or regulatory authorities: When required by
                  law or in response to a valid legal request.
                </li>
                <li data-id="element-405">
                  Marketing partners: But only with your explicit consent, which
                  you can withdraw at any time.
                </li>
              </ul>
            </section>
            <section data-id="element-406">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-407">
                8. Data Retention
              </h3>
              <p className="text-gray-700" data-id="element-408">
                We retain your personal data only as long as necessary to:
              </p>
              <ul className="list-disc pl-6 text-gray-700" data-id="element-409">
                <li data-id="element-410">Provide and manage our services to you effectively.</li>
                <li data-id="element-411">Comply with legal and regulatory requirements.</li>
                <li data-id="element-412">Resolve disputes or complaints.</li>
              </ul>
            </section>
            <section data-id="element-413">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-414">
                9. Children's Privacy
              </h3>
              <p className="text-gray-700" data-id="element-415">
                Our services are not intended for individuals under 16 years
                old. We do not knowingly collect personal data from minors. If
                we become aware that such data has been collected, we will take
                steps to delete it.
              </p>
            </section>
            <section data-id="element-416">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-417">
                10. Data Security
              </h3>
              <p className="text-gray-700" data-id="element-418">
                We implement strong security measures, including technical and
                organizational safeguards, to protect your information from
                unauthorized access, accidental loss, destruction, or
                alteration. While we strive for robust security, please
                understand that no system can guarantee 100% security during
                data transmission over the internet.
              </p>
            </section>
            <section data-id="element-419">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-420">
                11. International Data Transfers
              </h3>
              <p className="text-gray-700" data-id="element-421">
                Your data may be stored or processed outside the UK or European
                Economic Area by our service providers. Where this happens, we
                ensure appropriate safeguards are in place to protect your data
                in accordance with relevant data protection laws.
              </p>
            </section>
            <section data-id="element-422">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-423">
                12. Updates to This Policy
              </h3>
              <p className="text-gray-700" data-id="element-424">
                We may update this privacy policy occasionally to reflect
                changes in our practices, technology, or legal requirements. Any
                changes will be published here with the updated date. We
                encourage you to review this policy regularly to stay informed.
              </p>
            </section>
            <section data-id="element-425">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-426">
                13. Contact Us
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-427">
                If you have any questions or concerns about your data or this
                policy, please do not hesitate to contact us:
              </p>
              <ul className="list-disc pl-6 text-gray-700" data-id="element-428">
                <li data-id="element-429">Email: raimanish3080@gmail.com</li>
                <li data-id="element-430">Phone: 0800 055 4969</li>
              </ul>
            </section>
          </div>
          <div className="mt-8 p-6 bg-gray-50 rounded-lg" data-id="element-431">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-432">
              Questions About Your Data?
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-433">
              If you have any questions about how we handle your personal data
              or would like to exercise your rights, please contact our team.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-434">
              <a href="tel:08000554969" className="bg-[#3b82f6] text-white py-2 px-6 rounded-md font-medium hover:bg-[#1a3a6c] transition-colors text-center" data-id="element-435">
                Call 0800 055 4969
              </a>
              <a href="mailto:raimanish3080@gmail.com" className="bg-white text-[#1a3a6c] py-2 px-6 rounded-md font-medium border border-[#1a3a6c] hover:bg-gray-50 transition-colors text-center" data-id="element-436">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default PrivacyPolicy;